var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":_vm.justifyCenter ? 'center' : null}},[_c('v-col',{attrs:{"sm":"10","md":"8"}},[_c('v-card',{staticClass:"pa-3"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }